var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<i class="arrow"></i>\n<div class="mention">\n  <input class="js-mention" name="" type="text" value="" autocomplete="off"/>\n  <div class="mention__user-list js-user-list"></div>\n</div>\n';
}
return __p;
};
